<template>
  <validation-observer
    ref="observerSettings"
    v-slot="{ invalid }"
    slim>
    <oie-edit-wrapper :title="t('notificationsHeader')" class="my-notifications" :contained="true">
      <template v-if="notifications" #preview-content>
        <div class="my-notifications__preview">
          <p><span>{{ tStatic('email') }}: </span><span> {{ notifications.deliveryNotificationEmail }}</span></p>
          <p><span>{{ tStatic('phoneLabel') }}: </span><span>{{ notifications.deliveryNotificationPhone }}</span></p>
          <p><span>{{ t('newsletterLabel') }}: </span><span>{{ notifications.newsletter ? tStatic('genericYes') : tStatic('genericNo') }}</span></p>
        </div>
      </template>
      <template #edit-actions="{ toggle }">
        <oie-action-wrapper>
          <oie-base-action theme="skeleton" size="large" @click="exit(toggle)">
            {{ tStatic('genericClose') }}
          </oie-base-action>
          <oie-base-action
            size="large"
            :disabled="invalid"
            @click="save(toggle)">
            {{ tStatic('genericSave') }}
          </oie-base-action>
        </oie-action-wrapper>
      </template>
      <template v-if="notifications" #edit-content>
        <div class="input-column__container">
          <validation-provider v-slot="{ errors }" rules="email" slim>
            <oie-base-input
              id="my-pages-notification-email"
              v-model="notifications.deliveryNotificationEmail"
              :label-text="tStatic('email')"
              :placeholder="tStatic('emailPlaceholder')"
              :error-messages="errors"></oie-base-input>
          </validation-provider>

          <validation-provider v-slot="{errors}" rules="numeric" slim>
            <oie-base-input
              v-if="activeCountry"
              id="my-pages-notification-phone"
              v-model="phoneNumber"
              :error-messages="errors"
              :label-text="tStatic('phoneLabel')"
              :placeholder="tStatic('phonePlaceholderLabel')"
              :prefix-value="activeCountry.callingCode"></oie-base-input>
          </validation-provider>

          <oie-base-checkbox
            v-model="notifications.newsletter"
            is-for="my-pages-newsletter"
            :text="t('newsletterLabel')"
            css-classes="input-column__checkbox"></oie-base-checkbox>
        </div>
      </template>
    </oie-edit-wrapper>
  </validation-observer>
</template>

<script>
import httpService from '@/core/http-service'
import utils from '@/core/utils'
import _ from 'lodash'

export default {
  data() {
    return {
      notifications: null,
      pristineNotifications: null,
      phoneNumber: null
    }
  },
  computed: {
    activeCountry() {
      return this.clientModel.countryList.find(c => c.value === this.notifications.invoiceAddress.countryCode)
    }
  },
  async mounted() {
    const response = await httpService.get('auth/mynotifications')
    this.notifications = _.merge({}, response.data)
    this.pristineNotifications = _.merge({}, response.data)
    this.phoneNumber = utils.extractPhoneNumberFromFormating(this.notifications.deliveryNotificationPhone, this.activeCountry.callingCode)
  },
  methods: {
    async save(toggle) {
      if(this.phoneNumber) {
        this.notifications.deliveryNotificationPhone = utils.savePhoneNumberWithFormating(this.phoneNumber, this.activeCountry.callingCode)
      }

      await httpService.post('auth/mynotifications',
        { email: this.notifications.deliveryNotificationEmail,
          phone: this.notifications.deliveryNotificationPhone,
          newsletter: this.notifications.newsletter
        })

      this.pristineNotifications = _.merge({}, this.notifications)

      toggle()
    },
    exit(toggle) {
      this.notifications = _.merge({}, this.pristineNotifications)
      this.phoneNumber = utils.extractPhoneNumberFromFormating(this.pristineNotifications.deliveryNotificationPhone, this.activeCountry.callingCode)
      toggle()
    }
  }
}
</script>

<style lang="scss">
.my-notifications__preview p{
  @include body-smaller;
  margin: 0;
}
</style>
